/**
 * Load More Articles Module
 * Handles AJAX pagination and Category Filtering
 */
export function initLoadMoreArticles() {
  (function ($) {
    "use strict";

    // Selectors
    const $grid = $("#blog-grid");
    const $loadMoreBtn = $("#load-more");
    const $btnWrapper = $loadMoreBtn.parent(); // .blog-list__pagination-wrapper
    const $filterBtns = $("[data-category]"); // Any category filter buttons

    // State
    let currentPage = parseInt($loadMoreBtn.data("page")) || 1;
    let maxPages = parseInt($loadMoreBtn.data("max")) || 1;
    let currentCategory = "all";
    let isLoading = false;

    /**
     * Event: Load More Click
     */
    $loadMoreBtn.on("click", function (e) {
      e.preventDefault();

      if (isLoading || currentPage >= maxPages) return;

      currentPage++;
      fetchArticles(currentPage, currentCategory, false);
    });

    /**
     * Event: Category Filter Click
     * (Optional: Only if you add filter buttons to the UI later)
     */
    $filterBtns.on("click", function (e) {
      e.preventDefault();

      const $this = $(this);
      const category = $this.data("category");

      // UI Updates
      $filterBtns.removeClass("is-active");
      $this.addClass("is-active");

      // Reset State
      currentPage = 1;
      currentCategory = category;

      // Update max pages based on category data if available,
      // or rely on AJAX response to update it.

      fetchArticles(currentPage, currentCategory, true);
    });

    /**
     * Fetch Articles via AJAX
     * @param {number} page
     * @param {string} category
     * @param {boolean} replace - True to clear grid (filtering), False to append (pagination)
     */
    function fetchArticles(page, category, replace) {
      isLoading = true;

      // Visual Feedback
      $loadMoreBtn.addClass("btn--loading").prop("disabled", true);
      const originalText = $loadMoreBtn.find(".btn__text").text();
      $loadMoreBtn.find(".btn__text").text("Loading...");

      $.ajax({
        url: ducon_ajax.ajaxUrl, // Used the variable from functions.php
        type: "POST",
        dataType: "json",
        data: {
          action: "load_more_articles",
          nonce: ducon_ajax.nonce,
          page: page,
          category: category,
        },
        success: function (response) {
          if (response.success) {
            // 1. Update Grid
            if (replace) {
              $grid.html(response.data.content);
              // Update max pages for the new category context
              maxPages = response.data.max;
              $loadMoreBtn.show(); // Ensure button is visible if hidden previously
            } else {
              $grid.append(response.data.content);
            }

            // 2. Refresh Animations (AOS)
            if (typeof window.AOS !== "undefined") {
              window.AOS.refresh();
            }

            // 3. Update Button State
            $loadMoreBtn.removeClass("btn--loading").prop("disabled", false);
            $loadMoreBtn.find(".btn__text").text(originalText);

            // 4. Check if we reached the end
            if (page >= maxPages) {
              $loadMoreBtn.hide();
              showMessage("🎉 No more articles to show.");
            }
          } else {
            handleError(replace);
          }
        },
        error: function () {
          handleError(replace);
        },
        complete: function () {
          isLoading = false;
        },
      });
    }

    /**
     * Helper: Handle Errors or Empty States
     */
    function handleError(replace) {
      $loadMoreBtn.hide();

      if (replace) {
        $grid.html('<p class="blog-list__empty">No articles found.</p>');
      } else {
        showMessage("⚠ Error loading articles. Please try again.");
      }
    }

    /**
     * Helper: Show Feedback Message
     */
    function showMessage(msg) {
      // Remove existing messages first
      $btnWrapper.find(".blog-list__message").remove();

      // Append new message
      $btnWrapper.append(`<p class="blog-list__message">${msg}</p>`);
    }
  })(jQuery);
}
